import React from "react";
import { Modal, ModalBody } from "reactstrap";
import { withTranslation } from "react-i18next";
import crossIcon from "assets/images/cross.svg";
import staffStyles from "pages/Staff/staff.module.scss";

/**
 * Help Guide modal for the PMS Doctors and Patients lists.
 * Content depends on the active tab (doctors vs patients).
 *
 * @param {object} props
 * @param {boolean} props.isOpen
 * @param {(open: boolean) => void} props.onClose
 * @param {boolean} props.isDoctorsTab
 * @param {Function} props.t
 */
const PmsMembersHelpGuide = ({ isOpen, onClose, isDoctorsTab, t }) => {
  const closeModal = () => onClose(false);

  const doctorSections = [
    {
      titleKey: "pmsMembers.helpInviteADoctor",
      textKeys: ["pmsMembers.helpInviteADoctorText"],
    },
    {
      titleKey: "pmsMembers.helpSyncDoctorsAndPatients",
      textKeys: ["pmsMembers.helpSyncDoctorsText"],
    },
  ];

  const patientSections = [
    {
      titleKey: "pmsMembers.helpAutoInvitePatients",
      textKeys: [
        "pmsMembers.helpAutoInvitePatientsText",
        "pmsMembers.helpAutoInvitePatientsDisabledText",
      ],
    },
    {
      titleKey: "pmsMembers.helpNotificationsToNonRegisteredPatients",
      textKeys: ["pmsMembers.helpNotificationsToNonRegisteredPatientsText"],
    },
    {
      titleKey: "pmsMembers.helpInviteAPatient",
      textKeys: ["pmsMembers.helpInviteAPatientText"],
    },
    {
      titleKey: "pmsMembers.helpSyncDoctorsAndPatients",
      textKeys: ["pmsMembers.helpSyncPatientsText"],
    },
  ];

  const sections = isDoctorsTab ? doctorSections : patientSections;

  return (
    <Modal
      isOpen={isOpen}
      toggle={closeModal}
      className="modal-md modal-dialog-centered modal-lg"
      modalClassName="custom-modal"
    >
      <span
        className="close-btn"
        onClick={closeModal}
        onKeyDown={(e) =>
          (e.key === "Enter" || e.key === " ") && closeModal()
        }
        role="button"
        tabIndex={0}
      >
        <img src={crossIcon} alt="close" />
      </span>
      <ModalBody>
        <p className="title">{t("helpGuide")}</p>
        <div className={staffStyles.modal_container}>
          <h5 className={staffStyles.title_style}>
            {isDoctorsTab
              ? t("pmsMembers.helpDoctorListHeading")
              : t("pmsMembers.helpPatientListHeading")}
          </h5>
          <p>
            {isDoctorsTab
              ? t("pmsMembers.helpDoctorListIntro")
              : t("pmsMembers.helpPatientListIntro")}
          </p>
          <ul>
            {sections.map((section) => (
              <li key={section.titleKey}>
                <span className={staffStyles.title_style}>
                  {t(section.titleKey)}
                </span>
                {section.textKeys.map((textKey) => (
                  <p key={textKey}>{t(textKey)}</p>
                ))}
              </li>
            ))}
          </ul>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default withTranslation()(PmsMembersHelpGuide);
